import { track } from "./api";

const GOLD = "#D4AF37";

const arcText = (ctx, text, r, top) => {
  const chars = text.split("");
  const span = Math.min(0.42 * chars.length, 2.2);
  const start = top ? -Math.PI / 2 - span / 2 : Math.PI / 2 + span / 2;
  chars.forEach((ch, i) => {
    const a = top ? start + (span / Math.max(chars.length - 1, 1)) * i : start - (span / Math.max(chars.length - 1, 1)) * i;
    ctx.save();
    ctx.translate(r * Math.cos(a), r * Math.sin(a));
    ctx.rotate(top ? a + Math.PI / 2 : a - Math.PI / 2);
    ctx.fillText(ch, 0, 0);
    ctx.restore();
  });
};

const drawCard = ({ place, year, dishName }) => {
  const c = document.createElement("canvas");
  c.width = 1080;
  c.height = 1080;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#0C0A07";
  ctx.fillRect(0, 0, 1080, 1080);
  const g = ctx.createRadialGradient(540, 400, 60, 540, 400, 620);
  g.addColorStop(0, "rgba(212,175,55,0.18)");
  g.addColorStop(1, "rgba(212,175,55,0)");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, 1080, 1080);

  ctx.save();
  ctx.translate(540, 420);
  ctx.rotate(-8 * Math.PI / 180);
  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 14;
  ctx.setLineDash([12, 20]);
  ctx.beginPath();
  ctx.arc(0, 0, 290, 0, Math.PI * 2);
  ctx.stroke();
  ctx.setLineDash([]);
  ctx.lineWidth = 7;
  ctx.beginPath();
  ctx.arc(0, 0, 226, 0, Math.PI * 2);
  ctx.stroke();
  ctx.fillStyle = GOLD;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = "800 56px Georgia, serif";
  arcText(ctx, place, 258, true);
  ctx.font = "900 118px Georgia, serif";
  ctx.fillText(year, 0, 10);
  ctx.font = "700 34px Georgia, serif";
  arcText(ctx, "URBAN PASSPORT", 252, false);
  ctx.restore();

  ctx.textAlign = "center";
  ctx.fillStyle = GOLD;
  ctx.font = "700 34px Georgia, serif";
  ctx.fillText("S T O R Y   S T A M P   C O L L E C T E D", 540, 805);
  ctx.fillStyle = "#F9FAFB";
  ctx.font = "bold 66px Georgia, serif";
  ctx.fillText(dishName.toUpperCase(), 540, 880);
  ctx.fillStyle = "rgba(249,250,251,0.55)";
  ctx.font = "600 30px Georgia, serif";
  ctx.fillText("URBAN BY VEERGI  ·  MYURBANPASSPORT.COM", 540, 975);
  return c;
};

export const shareStamp = async ({ place, year, dishName }) => {
  const canvas = drawCard({ place, year, dishName });
  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  const file = new File([blob], "urban-story-stamp.png", { type: "image/png" });
  track("story_stamp_shared", { dish: dishName });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({
        files: [file],
        title: "Urban Passport story stamp",
        text: `I collected the ${dishName} story stamp at Urban by VeerGi!`,
      });
      return "shared";
    } catch (e) {
      if (e.name === "AbortError") return "cancelled";
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "urban-story-stamp.png";
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return "downloaded";
};
